<!-- DESC：审稿人邮件 -->
<template>
    <div class="reviewEmail-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Send Email to Reviewers of  {{ route.query.autoid }}</div>
                    <br />
                    <div class="info">
                        You can send email information to the reviewers here
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 邮件内容构建 -->
        <el-row>
            <el-col :span="15">
                <div class="email-box">
                    <!-- 标题 -->
                    <div style="margin-bottom:30px;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">
                        Email</div>
                    <el-card shadow="always">
                        <el-form :model="emailform" label-width="91px">
                            <el-form-item label="Subject:" required>
                                <el-input v-model="emailform.subject" />
                            </el-form-item>
                            <el-form-item label="Message:" required>
                                <el-input v-model="emailform.message" type="textarea" :rows="9"
                                    :autosize="{ minRows: 9, maxRows: 20 }" resize="none" />
                            </el-form-item>
                            <el-upload ref="uploadRef" class="upload-demo" :auto-upload="false" :limit="1"
                                :on-exceed="handleExceed" :http-request="sendemail" v-model:file-list="fileList">
                                <template #trigger>
                                    <el-text class="mx-1" style="margin-right: 10px;">Attachment:</el-text><el-button>select
                                        file</el-button>
                                </template>
                            </el-upload>
                            <el-divider border-style="dashed" />
                            <el-form-item required style="display: flex;align-items: center;">
                                <template #label>
                                    Subreviewers:
                                </template>
                                <el-checkbox-group v-model="emailform.correspondingList"
                                    style="display: flex;flex-direction: column;">
                                    <el-checkbox v-for="item in paperinfo.subList" :key="item.uid2" :label="item.email2">
                                        {{ item.firstname2 }}{{ item.lastname2 }} &lt;{{ item.email2 }}&gt;
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        <el-divider border-style="dashed" />
                        <div style="display: flex;justify-content: center;" @click="presend"><el-button type="primary">Send
                                Email</el-button>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import request from "../../network/request"
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router"
import { View, Document, Refresh, Position, Search, Plus, Message,ArrowLeftBold } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { ElLoading } from 'element-plus'

const route = useRoute()

// 文件列表
const fileList = ref([])
// 邮件表单信息
const emailform = ref({
    subject: `${route.query.acronym} submission ${route.query.autoid}`, message: "", correspondingList: []
})

const emailList = ref([])
// 上传文件对象
const uploadRef = ref()
// 上传文件覆盖
const handleExceed = (files) => {
    uploadRef.value.clearFiles()
    const file = files[0]
    file.uid = 0
    uploadRef.value.handleStart(file)
}
const paperinfo = ref({})

// 发送预处理
const presend = () => {
    emailList.value = emailform.value.correspondingList
    // 空值效验
    if (!emailform.value.subject) {
        ElMessage({
            message: `subject cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (!emailform.value.message) {
        ElMessage({
            message: `message cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (emailList.value.length == 0) {
        ElMessage({
            message: `emaillist cannot be empty`,
            type: 'warning',
        })
        return
    }
    // 空文件后端传值
    if (fileList.value.length == 0) {
        let data = {
            subject: emailform.value.subject,
            message: emailform.value.message,
            emailList: [...new Set(emailList.value)].join(","),
        }
        const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
        // 
        request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: 'the email has been sent',
                    type: 'success',
                })
                loading.close()
            }else{
                loading.close()
            }
        })
    }
    else {
        uploadRef.value.submit()
    }
}

// 附件形式发送邮件
const sendemail = (payload) => {
    let data = {
        subject: emailform.value.subject,
        message: emailform.value.message,
        emailList: [...new Set(emailList.value)].join(","),
        file: payload.file
    }
    const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'the email has been sent',
                type: 'success',
            })
            loading.close()
        }else{
            loading.close()
        }
    })
}

// 获取论文详细信息
function getPaperDetail() {
    request.post("/paper/detail", {
        pid: route.query.pid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        paperinfo.value = res.data
    })
}

onMounted(() => {
    getPaperDetail()
})

</script>

<style lang="scss">
.reviewEmail-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

}
</style>